import {AiImagePromptText} from '@Panels/ai-image-tooltip-text/ai-image-prompt-text';
import type {ReactElement} from 'react';

export function getPromptTextContentForAIImage(prompt: string): ReactElement<any> {
  return <AiImagePromptText prompt={prompt} />;
}
